import React, { useRef } from 'react';
import {
  Card,
  CardSection,
  IconButton,
  StackableRow,
  StackableRowItem,
  Textarea,
  useTextareaLineFill,
} from '@axiom/ui';
import type { FormPropsChildren } from '@axiom/ui';

import type { ChatForm } from '../../../schema/spark/chat-form-schema';
import { useSparkSession } from '../../hooks/useSparkSession';

import { ChatAttachButton } from './ChatAttachButton';
import { ChatAttachments } from './ChatAttachments';

export type ChatInputBarProps = {
  fireSubmit: FormPropsChildren<ChatForm>['fireSubmit'];
  values: FormPropsChildren<ChatForm>['values'];
};

export const ChatInputBar = ({ fireSubmit, values }: ChatInputBarProps) => {
  const {
    session: { shelf, transcript },
  } = useSparkSession();
  const { addAttachments, attachments, clearAttachments, removeAttachment } =
    shelf;
  const { isChatFull } = transcript;

  const promptRef = useRef<HTMLDivElement | null>(null);
  const { isNearWrap } = useTextareaLineFill({ containerRef: promptRef });

  return (
    <Card shadow="elevated" name="CHAT_INPUT_BAR">
      <CardSection>
        <ChatAttachments
          attachments={attachments}
          clearAttachments={clearAttachments}
          removeAttachment={removeAttachment}
        />
        <StackableRow isStacked={isNearWrap} name="CHAT_INPUT_ROW">
          <StackableRowItem area="leading" name="CHAT_ATTACH_ITEM">
            <ChatAttachButton
              addAttachments={addAttachments}
              disabled={isChatFull}
            />
          </StackableRowItem>
          <StackableRowItem area="main" name="CHAT_PROMPT_ITEM" ref={promptRef}>
            <Textarea
              formatting="modern"
              name="chat"
              placeholder="Ask Axiom Spark"
              submitOnEnter={!isChatFull}
              variation="seamless"
            />
          </StackableRowItem>
          <StackableRowItem area="trailing" name="CHAT_SUBMIT_ITEM">
            <IconButton
              disabled={isChatFull || !values.chat?.trim()}
              icon="arrow-up"
              name="SUBMIT_CHAT"
              onClick={() => {
                void fireSubmit();
              }}
              size="large"
            />
          </StackableRowItem>
        </StackableRow>
      </CardSection>
    </Card>
  );
};
